import { defaultsDeep } from "lodash";
import { DeepNullableObj, Patient } from "../types";
import { MockFn, createMock } from "./index";
import mockAccount from "./mockAccount";
import mockCareseeker from "./mockCareseeker";
import mockEvent from "./mockEvent";
import mockEventContext from "./mockEventContext";
import mockMedicalDiagnosis from "./mockMedicalDiagnosis";
import mockPatientNeeds from "./mockPatientNeeds";
import mockPatientProfile from "./mockPatientProfile";

const mockPatient: MockFn<Partial<DeepNullableObj<Patient>>> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "Patient",
      args,
      (shallow): DeepNullableObj<Patient> => ({
        archived: null,
        assignee: mockAccount({ ...shallow("Account") }),
        auctions: null,
        care_needs: mockPatientNeeds({ ...shallow("PatientNeeds") }),
        careseeker: mockCareseeker({ ...shallow("Careseeker") }),
        created_at: null,
        diagnosis: mockMedicalDiagnosis({ ...shallow("MedicalDiagnosis") }),
        drg_code: null,
        events: [
          mockEvent({
            ...shallow("Event"),
            context: mockEventContext({ message: "1" }),
            timestamp: 1543231800,
            type: 1,
          }),
          mockEvent({
            ...shallow("Event"),
            context: mockEventContext({ message: "2" }),
            timestamp: 1543232000,
            type: 2,
          }),
          mockEvent({
            ...shallow("Event"),
            context: mockEventContext({ message: "3" }),
            timestamp: 1543232000,
            type: 3,
          }),
          mockEvent({
            ...shallow("Event"),
            context: mockEventContext({ message: "4" }),
            timestamp: 1543232000,
            type: 4,
          }),
          mockEvent({
            ...shallow("Event"),
            context: mockEventContext({ message: "5" }),
            timestamp: 1543232000,
            type: 5,
          }),
        ],
        external_id: null,
        id: -1,
        kis_import: false,
        profile: mockPatientProfile({ ...shallow("PatientProfile") }),
        rehab_form: {
          medical_form_input: {
            content: null,
            iv: null,
            seald_content: null,
            type: null,
            updated_at: null,
          },
          request_form_input: {
            content: null,
            iv: null,
            seald_content: null,
            type: null,
            updated_at: null,
          },
        },
        seald_encryption_context: {
          auction_request_id: null,
          careprovider_id: null,
          careseeker_id: null,
          file_id: null,
          id: 1,
          patient_id: null,
          seald_display_id: null,
          seald_id: "seald-id",
          seald_type: null,
        },
        session_key_context: {
          has_session_keys: false,
          session_key: {
            account_id: 1,
            algorithm: null,
            auction_request_id: 1,
            careprovider_id: 1,
            careseeker_id: 1,
            id: 1,
            patient_id: 1,
            session_key: null,
            updated_at: 1,
          },
        },
        session_keys: [
          {
            account_id: -1,
            algorithm: null,
            auction_request_id: -1,
            careprovider_id: -1,
            id: -1,
            patient_id: -1,
            session_key: null,
            updated_at: 0,
          },
        ],
        social_worker: mockAccount({ ...shallow("Account") }),
        station: null,
        station_full: {
          description: null,
          id: -1,
          name: null,
          phone_number: null,
        },
        station_full_id: null,
        transport: {
          accompanying_person: {
            content: null,
            decrypted: null,
            iv: null,
            seald_content: null,
          },
          daily_transport_needed: null,
          require_accompanying_person: null,
          transport_organiser: null,
          transport_type: null,
        },
        user_id: "AAA-BBB-CCC",
        version: null,
      }),
    ),
  );

export default mockPatient;
